import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Section from 'components/common/Section';

import paths from 'routes/paths';
import envelope from 'assets/img/icons/spot-illustrations/16.png';

const ConfirmMail = () => {
  return (
    <Section className="py-0">
      <Row className="flex-center min-vh-100 py-6">
        <Col sm={10} md={8} lg={6} xl={5} className="col-xxl-4">
          <Card>
            <Card.Body className="p-4 p-sm-5">
              <div className="text-center">
                <img
                  className="d-block mx-auto mb-4"
                  src={envelope}
                  alt="sent"
                  width={100}
                />

                <h4>Please check your email!</h4>

                <p>Please click on the included link to reset your password.</p>

                <Button
                  as={Link}
                  color="primary"
                  size="sm"
                  className="mt-3"
                  to={paths.login}
                >
                  <FontAwesomeIcon
                    icon="chevron-left"
                    transform="shrink-4 down-1"
                    className="me-1"
                  />
                  Return to login
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Section>
  );
};

export default ConfirmMail;
